import React, { Fragment } from 'react'

import { useSelector } from 'react-redux'
import { Routes, Route, useLocation } from 'react-router-dom'
import WebFont from 'webfontloader'

import { AnimatePresence } from 'framer-motion/dist/framer-motion'

import { PathTemplate } from './page-templates/PathTemplate'
import * as Layout from './template-parts/layout'

import './App.scss'
import fonts from './assets/sass/fonts.scss'

WebFont.load({
	families: ['Circular Air', 'Gotham'],
	urls: [fonts],
})

const Header = React.memo(({ template }) => {
	const HeaderTemplate = Layout[template] ?? Layout['Header']
	return <HeaderTemplate />
})

const Footer = React.memo(({ template }) => {
	const FooterTemplate = Layout[template] ?? Layout['Footer']
	return <FooterTemplate />
})

const AppRoutes = React.memo(
	({ location }) => {
		return (
			<Routes location={location}>
				<Route
					path="*"
					element={<PathTemplate uri={location.pathname} />}
				/>
			</Routes>
		)
	},
	(prevProps, nextProps) =>
		prevProps.location.pathName === nextProps.location.pathName
)

function App() {
	const location = useLocation()
	const { header, footer } = useSelector(store => ({
		header: store.layout.header ?? 'Header',
		footer: store.layout.footer ?? 'Footer',
	}))

	return (
		<Fragment>
			<AnimatePresence mode="wait">
				<Header key={header} template={header} />
			</AnimatePresence>
			<AnimatePresence mode="wait">
				<AppRoutes key={location.pathname} location={location} />
			</AnimatePresence>
			<AnimatePresence mode="wait">
				<Footer key={footer} template={footer} />
			</AnimatePresence>
		</Fragment>
	)
}

export default App
